<template>
    <div class="container sm:px-10">
        <div class="block xl:grid gap-4">
            <!-- BEGIN: Register Form -->
            <div
                class="w-full max-w-md bg-white dark:bg-gray-900 rounded-lg shadow-lg p-8 m-auto my-10"
            >
                <div class="text-center mb-6">
                    <img
                        alt="NosDrought"
                        class="rounded-full mx-auto mb-4"
                        :src="require('@/assets/images/logo.png')"
                        style="width: 140px; height: 140px;"
                    />
                    <p class="text-gray-600 dark:text-gray-400">
                        Welcome back to NosDrought!
                    </p>
                </div>
                <div class="px-5 mb-4">
                    <label class="block text-gray-700 dark:text-gray-300">Username</label>
                    <input v-model="username" type="text"
                           class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-indigo-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300"
                           placeholder="Username" :class="{ 'border-red-500': error_username_text }">
                    <small v-if="error_username_text" class="text-red-500">{{ this.username_error }}</small>
                </div>
                <div class="px-5 mb-4">
                    <label class="block text-gray-700 dark:text-gray-300">Email</label>
                    <input v-model="register_email" type="email"
                           class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-indigo-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300"
                           placeholder="Email" :class="{ 'border-red-500': error_register_email_text }">
                    <small v-if="error_register_email_text" class="text-red-500">{{ this.register_email_error }}</small>
                </div>
                <div class="relative px-5 mb-4">
                    <label class="block text-gray-700 dark:text-gray-300">Password</label>
                    <div class="relative">
                        <input v-model="register_password" placeholder="Password"
                               :type="show_register_password_input ? 'text' : 'password'"
                               class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-indigo-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300"
                               :class="{ 'border-red-500': error_register_password_text }">
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                             @click="show_register_password">
                            <!-- Eye Icon SVG -->
                            <svg v-if="!show_register_password_input"
                                 xmlns="http://www.w3.org/2000/svg"
                                 class="h-5 w-5 text-gray-600 dark:text-gray-400"
                                 fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-.937 2.882-3.346 5-6.542 5-3.197 0-5.605-2.118-6.542-5z"/>
                            </svg>
                            <!-- Eye-Off Icon SVG -->
                            <svg v-if="show_register_password_input"
                                 xmlns="http://www.w3.org/2000/svg"
                                 class="h-5 w-5 text-gray-600 dark:text-gray-400"
                                 fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 012.125-3.176m4.858 4.858a3 3 0 114.242-4.242m-.85 6.042A2.998 2.998 0 0112 15a3 3 0 01-2.828-4.828m1.48 6.042L4.21 4.929"/>
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M4.21 4.929l15.18 15.18"/>
                            </svg>
                        </div>
                    </div>
                    <small v-if="error_register_password_text" class="text-red-500">{{this.register_password_error}}</small>
                </div>
                <div class="relative px-5 mb-4">
                    <label class="block text-gray-700 dark:text-gray-300">Confirm Password</label>
                    <div class="relative">
                        <input v-on:keyup="enterpress" v-model="confirm_password"
                               :type="show_confirm_password_input ? 'text' : 'password'"
                               class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-indigo-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300"
                               :class="{ 'border-red-500': error_confirm_password_text }">
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                             @click="show_confirm_password">
                            <!-- Eye Icon SVG -->
                            <svg v-if="!show_confirm_password_input"
                                 xmlns="http://www.w3.org/2000/svg"
                                 class="h-5 w-5 text-gray-600 dark:text-gray-400"
                                 fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-.937 2.882-3.346 5-6.542 5-3.197 0-5.605-2.118-6.542-5z"/>
                            </svg>
                            <!-- Eye-Off Icon SVG -->
                            <svg v-if="show_confirm_password_input"
                                 xmlns="http://www.w3.org/2000/svg"
                                 class="h-5 w-5 text-gray-600 dark:text-gray-400"
                                 fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 012.125-3.176m4.858 4.858a3 3 0 114.242-4.242m-.85 6.042A2.998 2.998 0 0112 15a3 3 0 01-2.828-4.828m1.48 6.042L4.21 4.929"/>
                                <path stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M4.21 4.929l15.18 15.18"/>
                            </svg>
                        </div>
                    </div>
                    <small v-if="error_confirm_password_text" class="text-red-500">{{ this.confirm_password_error }}</small>
                </div>
                <div class="flex px-5 mb-4 items-center text-gray-600 dark:text-gray-400">
                    <input v-model="terms_service" type="checkbox" class="mr-2 rounded focus:ring-indigo-500 cursor-pointer" id="terms_service">
                    <label class="cursor-pointer select-none" for="terms_service">
                        I agree to <a href="/terms_service" class="text-indigo-500 hover:underline">Terms of Service</a> and <a href="/privacy_policy" class="text-indigo-500 hover:underline">Privacy Policy</a>
                    </label>
                </div>
                <div class="flex justify-center mb-4" v-if="capchakey">
                    <vue-recaptcha
                        :sitekey="capchakey"
                        theme="dark"
                        style="display: flex; justify-content: center; height: 78px; margin-top: 10px; width: 100%"
                        @verify="verify"
                        @expired="expired"
                    ></vue-recaptcha>
                </div>
                <div class="flex justify-center mb-4 px-5">
                    <button :disabled="isButtonDisabled" @click="register()" type="button"
                            class="w-full py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 shadow-lg transition-all cursor-pointer">
                        Register
                    </button>
                </div>
                <div class="text-center mb-4 text-gray-600 dark:text-gray-400">
                    Already have an account? <a href="javascript:;" @click="toLogin()" class="text-indigo-500 hover:underline">Login</a>
                </div>
                <div class="text-center mb-4 text-gray-500 dark:text-gray-400">
                   ●  <a :href="elite" class="hover:underline">Elitepvpers</a> ● <a :href="cheat" class="hover:underline">Cheat-Gam3</a> ●  <a :href="inforge" class="hover:underline">Inforge</a> ● 
                </div>
            </div>
            <!-- END: Register Form -->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Toastify from "toastify-js";
import VueRecaptcha from "vue-recaptcha";

export default {
    components: {
        VueRecaptcha
    },
    data(){
        return {
        email: "",
        password: "",

        username: "",
        register_email: "",
        register_password: "",
        confirm_password: "",
        show: false,
        terms_service: false,

        error_email_text: false,
        error_register_email_text: false,
        error_password_text: false,
        error_register_password_text: false,
        error_confirm_password_text: false,
        login_failed: false,
        show_password_input: false,
        show_register_password_input: false,
        show_confirm_password_input: false,
        capcha : false,
        email_error: '',
        username_error:"username is required!",
        error_username_text: false,
        register_password_error: "password is required!",
        confirm_password_error: "Confirm password is required!",

        elite: "",
        cheat: "",
        inforge: '',
        discord: '',
        ragezone: '',
        capchakey: '6Ldzg-QqAAAAAN1h_mZkhrZ1-vOWLHWPzQF8Hjvc'
        }
    },
    computed: {
        isAuthenticated() {
            return this.$store.state.main.authToken !== null;
        },
        isButtonDisabled() {
           return !this.terms_service || !this.capcha;
        },
        darkMode() {
           return this.$store.state.main.darkMode;
        }
    },
    mounted() {
        document.body.classList.add('login');
        this.setDarkModeClass();
        this.getLinks();
    },
    methods: {
        setDarkModeClass() {
            this.darkMode
                ? document.documentElement.classList.add('dark')
                : document.documentElement.classList.remove('dark');
        },
        toLogin() {
          this.$router.push({
            name: 'login'
          });
        },
        toEpvp() {
            document.location.href = this.elite;
        },
        toRage() {
            document.location.href = this.ragezone;
        },
        toInforge() {
            document.location.href = this.inforge;
        },
        login() {
            let self = this;
            if(self.error_email_text || self.error_password_text){
                return;
            }

            self.$store.dispatch('main/login', {
                email: self.email,
                password: self.password
            }).then((res) => {
                if(res.data.status == "success"){
                    Toastify({
                        text: res.data.message,
                        duration: 3000,
                        newWindow: true,
                        close: false,
                        gravity: "bottom",
                        position: "center",
                        backgroundColor: "#2af109",
                        stopOnFocus: true
                    }).showToast();
                    self.$router.push({ path: "/dashboard" });
                } else {
                    self.login_failed = true;
                }

            })
            .catch(() => {
                // Handle login errors
            });
        },
        register() {
            let self = this;
            if(self.username == ""){
                self.error_username_text = true; self.username_error = "username is required!";
            }
            if(self.register_email ==""){
                self.error_register_email_text = ture; self.register_email_error = "register email is required!";
            }
            if(self.register_password == ""){
                self.error_register_password_text = true; self.register_password_error = "register password is required!";
            }
            if(self.confirm_password == ""){
                self.error_confirm_password_text = ture; self.confirm_password_error = "confirm password is required!";
            }
            if(self.error_confirm_password_text || self.error_register_password_text || self.error_username_text){
                return;
            }
            axios
                .post("/account/register", {
                fullName: self.username,
                email: self.register_email,
                password: self.register_password,
                })
                .then(function(response) {
                if(response.data.message == "success"){
                    Toastify({
                        text: response.data.response,
                        duration: 3000,
                        newWindow: true,
                        close: false,
                        gravity: "bottom",
                        position: "center",
                        backgroundColor: "#2af109",
                        stopOnFocus: true
                    }).showToast();
                    self.$router.push({
                      name: 'login'
                    });
                } else {
                    Toastify({
                        text: response.data.response,
                        duration: 3000,
                        newWindow: true,
                        close: false,
                        gravity: "bottom",
                        position: "center",
                        backgroundColor: "#e80404",
                        stopOnFocus: true
                    }).showToast();
                }
                })
                .catch(function(error) {

                });
            },
        showLogin(t){
            this.show = t;
        },
        enterpress(e){
            let self = this;
            if (e.keyCode === 13) {
                self.login();
            }
        },

        show_password(){
            this.show_password_input = !this.show_password_input;
        },

        show_register_password(){
            this.show_register_password_input = !this.show_register_password_input;
        },

        show_confirm_password(){
            this.show_confirm_password_input = !this.show_confirm_password_input;
        },

        verify(){
            this.capcha = true;
        },

        expired(){
            this.capcha = false;
        },

        getLinks(){
            let self = this;
            axios.get('/game/getData')
                .then((res)=>{
                    self.elite = res.data.result.elite;
                    self.info = res.data.result.inforge;
                    self.discord = res.data.result.discord;
                    self.ragezone = res.data.result.ragezone;
                    self.capchakey = res.data.result.captcha_key;
                });
        }
    },

    watch: {
        email(){
            if (this.email == ""){
                this.error_email_text = true; this.email_error = "The Email is required!";
            } else if(!(/^[^@]+@\w+(\.\w+)+\w$/.test(this.email))) {
                this.error_email_text = true; this.email_error = "Invalid Email Format";
            } else {
                this.error_email_text = false;
            }
        },

        password(){
            if (this.password == ""){
                this.error_password_text = true;
            } else {
                this.error_password_text = false;
            }
        },

        register_password(){
            if (this.register_password == ""){
                this.error_register_password_text = true;
                this.register_password_error = "The password is required!";
            } else if(this.register_password.length < 6){
                this.error_register_password_text = true;
                this.register_password_error = "The password must be at least 6 characters!";
            } else {
                this.error_register_password_text = false;
            }
        },

        confirm_password(){
            if (this.confirm_password == ""){
                this.error_confirm_password_text = true;
                this.confirm_password_error = "The confirm password is required!";
            } else if(this.confirm_password.length < 6){
                this.error_confirm_password_text = true;
                this.confirm_password_error = "The confirm password must be at least 6 characters!";
            } else if(this.register_password != this.confirm_password){
                this.error_confirm_password_text = true;
                this.confirm_password_error = "The confirm password does not matched!";
            } else {
                this.error_confirm_password_text = false;
            }
        },

        register_email(){
            if (this.register_email == ""){
                this.error_register_email_text = true; this.register_email_error = "The Email is required!";
            } else if(!(/^[^@]+@\w+(\.\w+)+\w$/.test(this.register_email))) {
                this.error_register_email_text = true; this.register_email_error = "Invalid Email Format";
            } else {
                this.error_register_email_text = false;
            }
        },

        username(){
            if(this.username == ""){
                this.error_username_text = true; this.username_error = "Username field is required!";
            } else if (this.username.length < 6){
                this.error_username_text = true; this.username_error = "Username must be at least 6 characters";
            } else {
                this.error_username_text = false;
            }
        }

    }
};
</script>

<style scoped>
/*
.login {
    background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
    min-height: 100vh;
}

.dark .login {
    background: linear-gradient(135deg, #1f2937, #111827);
}
*/

.container {
    z-index: 1111 !important;
    position: relative;
}

.login {
    background: url("/login.jpg") !important;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: cover !important;
    }

input:focus {
    border: 2px solid #6366f1; /* Darker border */
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3); /* Glow effect */
    padding: 12px 15px; /* Increase padding for better appearance */
    border-radius: 5px; /* Consistent rounded corners */
}

.text-indigo-500 {
    color: #6366f1;
}

.bg-indigo-600 {
    background-color: #6366f1;
}

.bg-indigo-700 {
    background-color: #4338ca;
}

.border-red-500 {
    border-color: #ef4444;
}

.text-red-500 {
    color: #ef4444;
}
</style>
